var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlyerCover = function SvgFlyerCover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flyer-cover_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".flyer-cover_svg__st3{fill:#260046}.flyer-cover_svg__st5{fill:#ea4403}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "flyer-cover_svg__SVGID_1_",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flyer-cover_svg__SVGID_00000043431031453273141030000007923507478830660777_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#flyer-cover_svg__SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flyer-cover_svg__SVGID_00000043431031453273141030000007923507478830660777_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M40 80c22.093 0 40-17.909 40-40C80 17.907 62.093-.001 40-.001S0 17.907 0 40c0 22.092 17.907 40 40 40"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flyer-cover_svg__SVGID_00000043431031453273141030000007923507478830660777_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.537 57.785c0 1.18-.966 2.146-2.146 2.146h-32.82a2.153 2.153 0 01-2.146-2.146V17.644c0-1.179.967-2.144 2.146-2.144h32.821c1.18 0 2.146.966 2.146 2.144v40.141z",
    className: "flyer-cover_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.575 62.354c0 1.18-.966 2.146-2.146 2.146h-32.82a2.153 2.153 0 01-2.146-2.146V22.213c0-1.179.967-2.144 2.146-2.144H59.43c1.18 0 2.146.966 2.146 2.144v40.141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.491 46.919a2.57 2.57 0 01-2.567-2.566.52.52 0 011.042 0c0 .841.685 1.525 1.525 1.525s1.525-.684 1.525-1.525V31.797a.52.52 0 111.042 0v12.555a2.57 2.57 0 01-2.567 2.567M43.537 27.855a.521.521 0 01-.521-.521v-1.983a.521.521 0 011.043 0v1.983a.522.522 0 01-.522.521",
    className: "flyer-cover_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.591 35.874c1.32 0 2.456.719 2.99 1.76.534-1.04 1.67-1.76 2.99-1.76 1.32 0 2.457.719 2.991 1.76.533-1.04 1.67-1.76 2.99-1.76s2.456.719 2.99 1.76c.533-1.04 1.67-1.76 2.99-1.76 1.333 0 2.478.733 3.006 1.788-.029-6.604-5.389-11.583-12.001-11.583-6.63 0-12.004 5.007-12.004 11.636h.026c.514-1.083 1.677-1.841 3.032-1.841",
    className: "flyer-cover_svg__st5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.791 52.956c0-.723.59-1.315 1.315-1.315h23.827c.723 0 1.313.592 1.313 1.315v.839c0 .723-.59 1.315-1.313 1.315H31.106a1.318 1.318 0 01-1.315-1.315v-.839z",
    className: "flyer-cover_svg__st5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.791 59.16c0-.723.59-1.315 1.315-1.315h18.505a1.32 1.32 0 011.315 1.315v.839a1.32 1.32 0 01-1.315 1.315H31.106a1.318 1.318 0 01-1.315-1.315v-.839z",
    className: "flyer-cover_svg__st5"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlyerCover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flyer-cover.92b69dcb4cd88a268288e098fe9eb3d6.svg";